import { Dialog, DialogTitle, DialogContent, TextField, DialogActions } from "@mui/material";
import { useState } from "react";
import { useSnackbar } from "../contexts/SnackbarContext";
import { useAuthenticatedFetch } from "../utils/auth-fetch";

export const ChangePasswordDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const authenticatedFetch = useAuthenticatedFetch();
  const { showSnackbar } = useSnackbar();

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    await authenticatedFetch("/api/user/update/password", {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    }).then(res => {
      if (res.ok) {
        showSnackbar('Password changed successfully', 'success');
        onClose();
      } else {
        showSnackbar('Failed to change password', 'error');
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Change Password</DialogTitle>
      <form onSubmit={handleSubmit} className='pw-4'>
        <DialogContent>
          <TextField
            label="Current Password"
            type="password"
            name="currentPassword"
            value={formData.currentPassword}
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
          />

          <TextField
            label="New Password"
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
          />

          <TextField
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            className="w-36 text-orange-600 py-2 m-2 px-4 rounded float-end"
            onClick={onClose}
          >
            Close
          </button>
          <button
            type="submit"
            className="w-36 bg-orange-600 text-white py-2 m-2 px-4 rounded hover:bg-orange-700 float-end"
          >
            Change
          </button>
        </DialogActions>
      </form>
    </Dialog>
  );
};